const Loader = () => {
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
            <img src="/assets/load.gif" alt="Loading..." />
        </div>
    );
};

export default Loader;
